import {Component, inject, OnInit} from '@angular/core';
import {RouterModule} from '@angular/router';
import {MemoryService} from '../../../../core/services/memory.service';
import {CourseService} from '../../course.service';
import {LogoComponent} from '../../../../shared/components/logo/logo.component';
import {BreakpointObserver} from '@angular/cdk/layout';
import {MatDivider} from '@angular/material/divider';
import {TranslocoPipe, TranslocoService} from '@jsverse/transloco';
import {MatSelectModule} from '@angular/material/select';
import {MatInputModule} from '@angular/material/input';
import {CourseCategoryDto} from '../../dtos/coursecategory.dto';
import {CourseCategoryQueryDto} from '../../dtos/coursecategoryquery.dto';
import {GroupSeriesQueryDto} from '../../dtos/groupseriesquery.dto';
import {GroupSeriesInfoDto} from '../../dtos/groupseriesinfo.dto';
import {CourseCardComponent} from '../course-card/course-card.component';
import {MatDialog} from '@angular/material/dialog';
import {CourseInfoDialog} from '../../dialogs/course-info/course-info.dialog';
import {FormControl, ReactiveFormsModule} from '@angular/forms';
import {HttpErrorResponse} from '@angular/common/http';
import {ErrorService} from '../../../../core/services/error.service';


@Component({
  selector: 'app-course-list',
  imports: [
    LogoComponent,
    RouterModule,
    MatDivider,
    TranslocoPipe,
    MatSelectModule,
    MatInputModule,
    CourseCardComponent,
    ReactiveFormsModule
  ],
  templateUrl: './course-list.component.html',
  styleUrl: './course-list.component.scss'
})
export class CourseListComponent implements OnInit {

  memoryService = inject(MemoryService);
  courseService = inject(CourseService);
  errorService = inject(ErrorService);
  translocoService = inject(TranslocoService);
  dialog: MatDialog = inject(MatDialog);
  mode: 'mobile' | 'tablet' | 'desktop' = 'desktop';
  categories: CourseCategoryDto[] = [];
  courses: GroupSeriesInfoDto[] = [];
  categoryForm: FormControl = new FormControl("");

  constructor(private breakpointObserver: BreakpointObserver) {
    this.breakpointObserver.observe([
      '(max-width: 980px)',     // mobile
      '(min-width: 981px) and (max-width: 999px)', // tablet
      '(min-width: 1000px)'      // desktop
    ]).subscribe(result => {
      if (result.breakpoints['(max-width: 980px)']) {
        this.mode = 'mobile';
      } else if (result.breakpoints['(min-width: 981px) and (max-width: 999px)']) {
        this.mode = 'tablet';
      } else if (result.breakpoints['(min-width: 1000px)']) {
        this.mode = 'desktop';
      }
    });
  }

  ngOnInit() {
    const payload: CourseCategoryQueryDto = {
      locationId: this.memoryService.locationId,
      customerId: this.memoryService.customerId
    };
    this.courseService.queryCategories(payload).subscribe({
      next: (dtos: CourseCategoryDto[]) => {
        this.categories = dtos;
        const initialValue = this.memoryService.categoryGroup;
        this.categoryForm = new FormControl(initialValue);
        if(initialValue){
          this.loadGroups(initialValue);
        }
      },
      error: (error: HttpErrorResponse) => {
        this.errorService.handleError(error, this.translocoService.translate('error.title.courses'));
      }
    });
  }

  loadGroups(name: string) {
    const payload: GroupSeriesQueryDto = {
      locationId: this.memoryService.locationId,
      customerId: this.memoryService.customerId,
      patientId: this.memoryService.patientId,
      name: name
    };
    this.courseService.loadCourses(payload).subscribe({
      next: (dtos: GroupSeriesInfoDto[]) => {
        this.courses = dtos;
      }
    });
  }

  coursesLeft() {
    if (!this.courses) {
      return [];
    }

    const mid = Math.ceil(this.courses.length / 2);
    // Split the array
    return this.courses.slice(0, mid);
  }

  coursesRight() {
    if (!this.courses) {
      return [];
    }

    const mid = Math.ceil(this.courses.length / 2);
    return this.courses.slice(mid);
  }

  onCardClicked(item: GroupSeriesInfoDto) {
    this.dialog.open(CourseInfoDialog, {autoFocus: false, maxHeight: 'calc(100vh - 48px)', data: {course: item}});
  }
}
